// All custom overrides is a request from the UX team.
// https://www.figma.com/design/lzFuINllWqSiBrfRUKe6sq/Smart-FM---All-Designs?node-id=12152-49218

import { EmeraldBanner, EmeraldBannerInputs } from '@emerald-react/banner';
import clsx from 'clsx';
import './styles.scss';
import { Box } from '../Box';
import { Typography } from '../Typography';

export interface BannerProps extends Omit<EmeraldBannerInputs, 'open'> {
  isDismissable?: boolean;
}

export function Banner(props: BannerProps) {
  const { isDismissable = true, content, ...otherProps } = props;
  return (
    <Box
      className={clsx('emerald-banner-wrapper', {
        'emerald-banner-wrapper--dismissable': !isDismissable,
      })}
    >
      <EmeraldBanner
        open={true}
        content={<Typography variant='Calibre/Body 2'>{content}</Typography>}
        {...otherProps}
      />
    </Box>
  );
}
